import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    backdrop: {
      zIndex: 999,
      color: '#FFFFFF',
    },
  }),
);
